import {IntroductionState} from './introduction-state'

export const initialState: IntroductionState = {}
